<template>
  <div>
    <Spin size="large" fix v-if="!previewCAGuid">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>正在接收已签章的材料文件，可能需要几分钟，请稍等...</div>
    </Spin>
    <div class="caBox">
      <embed v-if="previewCAGuid" :src="$url + previewCAGuid" type="application/pdf" width="100%" height="765" />

    </div>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,-1)">上一步</Button>
        <Button type="primary" @click="next('form',1)">下一步</Button>

      </div>
    </div>
  </div>
</template>
<script lang="js">
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      count: 0, //操作
      uploadData: {},
      QRshow: false,
      loading: false,
        QRcode: '',
      
        timer: null,
        key: null,
        previewCAGuid: '',
      currentGuid:'',
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
    }
  },
    mounted() {
    const timestamp = this.$route.query.timestamp
    this.currentGuid = this.$route.query.guid
  
    this.getPreviewCAGuid(timestamp)
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name == null) {
        this.$emit('next', this.appInfoDataType['全部'])

        return
      }
      //下一步

      this.$emit('next', this.$store.state.appInfoDataType['QrSub'])
    },

    // 核验经办人 获取个人信息轮询
    getPreviewCAGuid(timestamp) {
      let _this = this
        const poll = async () => {
          try {
      
        let { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/GetAppSignFile`, {
          params: { guid:this.currentGuid,timestamp },
        })
        if (data.result.success) {
          
          // 是 直接提交
            this.previewCAGuid = data.result.previewUrl
        } else {
          _this.timer = setTimeout(poll, 2500)
              }
         } catch (error) {
            _this.$Message.error({
              content: '获取失败',
              background: true,
              duration: 6,
            })
          }
      }
      poll()
    },
  },
}

</script>
<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.caBox {
  min-height: 600px;
}
</style>